import { render, staticRenderFns } from "./FormTree.vue?vue&type=template&id=8ca33f52"
import script from "./FormTree.vue?vue&type=script&lang=ts"
export * from "./FormTree.vue?vue&type=script&lang=ts"
import style0 from "./FormTree.vue?vue&type=style&index=0&id=8ca33f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports